import type { Locale } from ".";

export const messages = {
  feedback: {
    "en-US": "Feedback",
    "es-ES": "Comentarios",
    "fr-FR": "Retour",
    "hi-IN": "प्रतिक्रिया",
    "ja-JP": "フィードバック",
    "ko-KR": "피드백",
    "zh-CN": "反馈",
    "fa-IR": "بازخورد",
    "uk-UA": "Відгук",
    "pt-BR": "Comentários",
  },
  feedback_header: {
    "en-US": "Share feedback",
    "es-ES": "Compartir comentarios",
    "fr-FR": "Partager des commentaires",
    "hi-IN": "प्रतिक्रिया साझा करें",
    "ja-JP": "フィードバックを共有",
    "ko-KR": "피드백 공유",
    "zh-CN": "分享反馈",
    "fa-IR": "به اشتراک گذاری بازخورد",
    "uk-UA": "Поділитися відгуком",
    "pt-BR": "Compartilhar comentários",
  },
  feedback_title: {
    "en-US": "How do you feel about Knoword?",
    "es-ES": "¿Qué opinas de Knoword?",
    "fr-FR": "Que pensez-vous de Knoword ?",
    "hi-IN": "Knoword के बारे में आपका क्या विचार है?",
    "ja-JP": "Knoword についてどう思いますか？",
    "ko-KR": "Knoword에 대한 의견을 알려주세요.",
    "zh-CN": "您对 Knoword 有何感受？",
    "fa-IR": "نظر شما در مورد Knoword چیست؟",
    "uk-UA": "Що ви думаєте про Knoword?",
    "pt-BR": "O que você acha do Knoword?",
  },
  feedback_label: {
    "en-US": "Additional notes",
    "es-ES": "Notas adicionales",
    "fr-FR": "Remarques supplémentaires",
    "hi-IN": "अतिरिक्त नोट",
    "ja-JP": "追加のメモ",
    "ko-KR": "추가 사항",
    "zh-CN": "附加说明",
    "fa-IR": "یادداشت های اضافی",
    "uk-UA": "Додаткові примітки",
    "pt-BR": "Notas adicionais",
  },
  feedback_placeholder: {
    "en-US": "Anything else you'd like to share? (optional)",
    "es-ES": "¿Hay algo más que te gustaría compartir? (opcional)",
    "fr-FR": "Avez-vous autre chose à partager ? (facultatif)",
    "hi-IN": "क्या आपको कुछ और साझा करना है? (वैकल्पिक)",
    "ja-JP": "他に共有したいことはありますか？（任意）",
    "ko-KR": "공유하고 싶은 다른 내용이 있나요? (선택 사항)",
    "zh-CN": "您还想分享其他内容吗？（可选）",
    "fa-IR": "آیا چیز دیگری برای به اشتراک گذاشتن دارید؟ (اختیاری)",
    "uk-UA": "Що-небудь ще, що ви хочете поділитися? (необов'язково)",
    "pt-BR":
      "Há mais alguma coisa que você gostaria de compartilhar? (opcional)",
  },
  feedback_submit: {
    "en-US": "Submit feedback",
    "es-ES": "Enviar comentarios",
    "fr-FR": "Envoyer des commentaires",
    "hi-IN": "प्रतिक्रिया जमा करें",
    "ja-JP": "フィードバックを送信",
    "ko-KR": "피드백 제출",
    "zh-CN": "提交反馈",
    "fa-IR": "ارسال بازخورد",
    "uk-UA": "Відправити відгук",
    "pt-BR": "Enviar comentários",
  },
  feedback_success: {
    "en-US": "Thank you for your feedback!",
    "es-ES": "¡Gracias por tus comentarios!",
    "fr-FR": "Merci pour vos commentaires !",
    "hi-IN": "आपकी प्रतिक्रिया के लिए धन्यवाद!",
    "ja-JP": "フィードバックありがとうございます！",
    "ko-KR": "피드백 감사합니다!",
    "zh-CN": "感谢您的反馈！",
    "fa-IR": "از بازخورد شما متشکرم!",
    "uk-UA": "Дякуємо за ваш відгук!",
    "pt-BR": "Obrigado pelo seu feedback!",
  },
  search_placeholder: {
    "en-US": "Search for anything",
    "es-ES": "Buscar cualquier cosa",
    "fr-FR": "Rechercher n'importe quoi",
    "hi-IN": "कुछ भी खोजें",
    "ja-JP": "何でも検索",
    "ko-KR": "모든 것을 검색",
    "zh-CN": "搜索任何内容",
    "fa-IR": "هر چیزی را جستجو کنید",
    "uk-UA": "Шукати все",
    "pt-BR": "Pesquisar qualquer coisa",
  },
  create: {
    "en-US": "Create",
    "es-ES": "Crear",
    "fr-FR": "Créer",
    "hi-IN": "बनाएँ",
    "ja-JP": "作成",
    "ko-KR": "만들기",
    "zh-CN": "创建",
    "fa-IR": "ایجاد",
    "uk-UA": "Створити",
    "pt-BR": "Criar",
  },
  create_pack: {
    "en-US": "Create a pack",
    "es-ES": "Crear un paquete",
    "fr-FR": "Créer un pack",
    "hi-IN": "पैक बनाएं",
    "ja-JP": "パックを作成",
    "ko-KR": "팩 만들기",
    "zh-CN": "创建一个包",
    "fa-IR": "ایجاد یک بسته",
    "uk-UA": "Створити пакет",
    "pt-BR": "Criar um pacote",
  },
  create_pack_description: {
    "en-US": "Build a custom word set",
    "es-ES": "Construir un conjunto de palabras personalizado",
    "fr-FR": "Construire un ensemble de mots personnalisé",
    "hi-IN": "एक कस्टम शब्द सेट बनाएं",
    "ja-JP": "カスタムワードセットを構築",
    "ko-KR": "사용자 지정 단어 세트 만들기",
    "zh-CN": "构建自定义单词集",
    "fa-IR": "ایجاد یک مجموعه کلمات سفارشی",
    "uk-UA": "Створити набір слів на замовлення",
    "pt-BR": "Criar um conjunto de palavras personalizado",
  },
  generate_pack: {
    "en-US": "Generate a pack",
    "es-ES": "Generar un paquete",
    "fr-FR": "Générer un pack",
    "hi-IN": "पैक उत्पन्न करें",
    "ja-JP": "パックを生成",
    "ko-KR": "팩 생성",
    "zh-CN": "生成一个包",
    "fa-IR": "ایجاد یک بسته",
    "uk-UA": "Згенерувати пакет",
    "pt-BR": "Gerar um pacote",
  },
  generate_pack_description: {
    "en-US": "Get started in seconds",
    "es-ES": "Comience en segundos",
    "fr-FR": "Commencez en quelques secondes",
    "hi-IN": "कुछ सेकंड में शुरू हो जाएं",
    "ja-JP": "数秒で始める",
    "ko-KR": "몇 초 만에 시작하세요",
    "zh-CN": "几秒钟内开始",
    "fa-IR": "در چند ثانیه شروع کنید",
    "uk-UA": "Почніть за кілька секунд",
    "pt-BR": "Comece em segundos",
  },
  create_assignment: {
    "en-US": "Create an assignment",
    "es-ES": "Crear una tarea",
    "fr-FR": "Créer une tâche",
    "hi-IN": "एक असाइनमेंट बनाएं",
    "ja-JP": "課題を作成",
    "ko-KR": "과제 만들기",
    "zh-CN": "创建一个作业",
    "fa-IR": "ایجاد یک تکلیف",
    "uk-UA": "Створити завдання",
    "pt-BR": "Criar uma tarefa",
  },
  create_assignment_description: {
    "en-US": "Track student progress",
    "es-ES": "Seguimiento del progreso del estudiante",
    "fr-FR": "Suivi de la progression des élèves",
    "hi-IN": "छात्र प्रगति का ट्रैक करें",
    "ja-JP": "学生の進捗を追跡",
    "ko-KR": "학생 진행 상황 추적",
    "zh-CN": "跟踪学生进度",
    "fa-IR": "پیگیری پیشرفت دانش آموز",
    "uk-UA": "Відстеження прогресу учнів",
    "pt-BR": "Acompanhar o progresso do aluno",
  },
  my_packs: {
    "en-US": "My packs",
    "es-ES": "Mis paquetes",
    "fr-FR": "Mes packs",
    "hi-IN": "मेरे पैक",
    "ja-JP": "私のパック",
    "ko-KR": "내 팩",
    "zh-CN": "我的包",
    "fa-IR": "بسته های من",
    "uk-UA": "Мої пакети",
    "pt-BR": "Meus pacotes",
  },
  my_assignments: {
    "en-US": "My assignments",
    "es-ES": "Mis tareas",
    "fr-FR": "Mes tâches",
    "hi-IN": "मेरे असाइनमेंट",
    "ja-JP": "私の課題",
    "ko-KR": "내 과제",
    "zh-CN": "我的作业",
    "fa-IR": "تکالیف من",
    "uk-UA": "Мої завдання",
    "pt-BR": "Minhas tarefas",
  },
  my_bookmarks: {
    "en-US": "My bookmarks",
    "es-ES": "Mis marcadores",
    "fr-FR": "Mes signets",
    "hi-IN": "मेरे बुकमार्क",
    "ja-JP": "私のブックマーク",
    "ko-KR": "내 북마크",
    "zh-CN": "我的书签",
    "fa-IR": "نشانه های من",
    "uk-UA": "Мої закладки",
    "pt-BR": "Meus favoritos",
  },
  account_settings: {
    "en-US": "Account settings",
    "es-ES": "Configuración de la cuenta",
    "fr-FR": "Paramètres du compte",
    "hi-IN": "खाता सेटिंग्स",
    "ja-JP": "アカウント設定",
    "ko-KR": "계정 설정",
    "zh-CN": "帐户设置",
    "fa-IR": "تنظیمات حساب",
    "uk-UA": "Налаштування облікового запису",
    "pt-BR": "Configurações da conta",
  },
  billing_settings: {
    "en-US": "Billing settings",
    "es-ES": "Configuración de facturación",
    "fr-FR": "Paramètres de facturation",
    "hi-IN": "बिलिंग सेटिंग्स",
    "ja-JP": "請求設定",
    "ko-KR": "청구 설정",
    "zh-CN": "结算设置",
    "fa-IR": "تنظیمات صورتحساب",
    "uk-UA": "Налаштування виставлення рахунків",
    "pt-BR": "Configurações de cobrança",
  },
  log_out: {
    "en-US": "Log out",
    "es-ES": "Cerrar sesión",
    "fr-FR": "Se déconnecter",
    "hi-IN": "लॉग आउट",
    "ja-JP": "ログアウト",
    "ko-KR": "로그아웃",
    "zh-CN": "登出",
    "fa-IR": "خروج از سیستم",
    "uk-UA": "Вийти",
    "pt-BR": "Sair",
  },
  log_in: {
    "en-US": "Log in",
    "es-ES": "Iniciar sesión",
    "fr-FR": "Se connecter",
    "hi-IN": "लॉग इन",
    "ja-JP": "ログイン",
    "ko-KR": "로그인",
    "zh-CN": "登录",
    "fa-IR": "ورود به سیستم",
    "uk-UA": "Увійти",
    "pt-BR": "Entrar",
  },
  sign_up: {
    "en-US": "Sign up",
    "es-ES": "Regístrate",
    "fr-FR": "S'inscrire",
    "hi-IN": "साइन अप करें",
    "ja-JP": "サインアップ",
    "ko-KR": "가입하기",
    "zh-CN": "注册",
    "fa-IR": "ثبت نام",
    "uk-UA": "Зареєструватися",
    "pt-BR": "Registrar",
  },
  quick_play: {
    "en-US": "Quick Play",
    "es-ES": "Juego rápido",
    "fr-FR": "Jeu rapide",
    "hi-IN": "त्वरित खेल",
    "ja-JP": "クイックプレイ",
    "ko-KR": "빠른 게임",
    "zh-CN": "快速游戏",
    "fa-IR": "بازی سریع",
    "uk-UA": "Швидка гра",
    "pt-BR": "Jogo rápido",
  },
  select_game_mode: {
    "en-US": "Select a game mode",
    "es-ES": "Selecciona un modo de juego",
    "fr-FR": "Sélectionnez un mode de jeu",
    "hi-IN": "एक गेम मोड चुनें",
    "ja-JP": "ゲームモードを選択",
    "ko-KR": "게임 모드 선택",
    "zh-CN": "选择游戏模式",
    "fa-IR": "یک حالت بازی انتخاب کنید",
    "uk-UA": "Виберіть режим гри",
    "pt-BR": "Selecione um modo de jogo",
  },
  game_settings: {
    "en-US": "Game settings",
    "es-ES": "Configuración del juego",
    "fr-FR": "Paramètres du jeu",
    "hi-IN": "गेम सेटिंग्स",
    "ja-JP": "ゲーム設定",
    "ko-KR": "게임 설정",
    "zh-CN": "游戏设置",
    "fa-IR": "تنظیمات بازی",
    "uk-UA": "Налаштування гри",
    "pt-BR": "Configurações do jogo",
  },
  settings: {
    "en-US": "Settings",
    "es-ES": "Configuraciones",
    "fr-FR": "Réglages",
    "hi-IN": "सेटिंग्स",
    "ja-JP": "設定",
    "ko-KR": "설정",
    "zh-CN": "设置",
    "fa-IR": "تنظیمات",
    "uk-UA": "Налаштування",
    "pt-BR": "Configurações",
  },
  time_limit: {
    "en-US": "Time limit",
    "es-ES": "Límite de tiempo",
    "fr-FR": "Limite de temps",
    "hi-IN": "समय सीमा",
    "ja-JP": "時間制限",
    "ko-KR": "시간 제한",
    "zh-CN": "时间限制",
    "fa-IR": "زمان محدود",
    "uk-UA": "Часове обмеження",
    "pt-BR": "Limite de tempo",
  },
  none: {
    "en-US": "None",
    "es-ES": "Ninguno",
    "fr-FR": "Aucun",
    "hi-IN": "कोई नहीं",
    "ja-JP": "なし",
    "ko-KR": "없음",
    "zh-CN": "无",
    "fa-IR": "هیچ",
    "uk-UA": "Немає",
    "pt-BR": "Nenhum",
  },
  junior: {
    "en-US": "Junior",
    "es-ES": "Junior",
    "fr-FR": "Junior",
    "hi-IN": "जूनियर",
    "ja-JP": "ジュニア",
    "ko-KR": "초급",
    "zh-CN": "初级",
    "fa-IR": "جونیور",
    "uk-UA": "Юніор",
    "pt-BR": "Júnior",
  },
  junior_description: {
    "en-US": "Simple words with picture clues",
    "es-ES": "Palabras simples con pistas visuales",
    "fr-FR": "Mots simples avec indices visuels",
    "hi-IN": "चित्र संकेत के साथ सरल शब्द",
    "ja-JP": "画像の手がかりがある簡単な単語",
    "ko-KR": "그림 단서가 있는 간단한 단어",
    "zh-CN": "带有图片提示的简单单词",
    "fa-IR": "کلمات ساده با سرنخ های تصویری",
    "uk-UA": "Прості слова з підказками зображення",
    "pt-BR": "Palavras simples com dicas visuais",
  },
  basic: {
    "en-US": "Basic",
    "es-ES": "Básico",
    "fr-FR": "Basique",
    "hi-IN": "मूल",
    "ja-JP": "基本",
    "ko-KR": "기본",
    "zh-CN": "基本",
    "fa-IR": "پایه",
    "uk-UA": "Основний",
    "pt-BR": "Básico",
  },
  basic_description: {
    "en-US": "Everyday words with multiple choice answers",
    "es-ES": "Palabras cotidianas con respuestas de opción múltiple",
    "fr-FR": "Mots du quotidien avec réponses à choix multiples",
    "hi-IN": "विकल्प बहुविकल्पी उत्तर के साथ दिनचर्या शब्द",
    "ja-JP": "選択肢のある日常の単語",
    "ko-KR": "다중 선택 답변이 있는 일상 단어",
    "zh-CN": "带有多项选择答案的日常单词",
    "fa-IR": "کلمات روزمره با پاسخ های چند گزینه ای",
    "uk-UA": "Звичайні слова з варіантами відповідей",
    "pt-BR": "Palavras do dia a dia com respostas de múltipla escolha",
  },
  intermediate: {
    "en-US": "Intermediate",
    "es-ES": "Intermedio",
    "fr-FR": "Intermédiaire",
    "hi-IN": "इंटरमीडिएट",
    "ja-JP": "中級",
    "ko-KR": "중급",
    "zh-CN": "中级",
    "fa-IR": "متوسط",
    "uk-UA": "Проміжний",
    "pt-BR": "Intermediário",
  },
  intermediate_description: {
    "en-US": "Test your typing and spelling skills with interesting words",
    "es-ES":
      "Pon a prueba tus habilidades de escritura y ortografía con palabras interesantes",
    "fr-FR":
      "Testez vos compétences en dactylographie et en orthographe avec des mots intéressants",
    "hi-IN":
      "रोमांचक शब्दों के साथ अपनी टाइपिंग और वर्तनी कौशल का परीक्षण करें",
    "ja-JP": "面白い単語でタイピングとスペルのスキルをテストしてください",
    "ko-KR": "흥미로운 단어로 타자 및 철자 실력을 테스트하세요",
    "zh-CN": "通过有趣的单词测试您的打字和拼写技能",
    "fa-IR": "مهارت های تایپ و املای خود را با کلمات جالب آزمایش کنید",
    "uk-UA":
      "Перевірте свої навички набору тексту та правопису цікавими словами",
    "pt-BR":
      "Teste suas habilidades de digitação e ortografia com palavras interessantes",
  },
  advanced: {
    "en-US": "Advanced",
    "es-ES": "Avanzado",
    "fr-FR": "Avancé",
    "hi-IN": "उन्नत",
    "ja-JP": "上級",
    "ko-KR": "고급",
    "zh-CN": "高级",
    "fa-IR": "پیشرفته",
    "uk-UA": "Розширений",
    "pt-BR": "Avançado",
  },
  advanced_description: {
    "en-US": "Challenging words to level up your vocabulary",
    "es-ES": "Palabras desafiantes para mejorar tu vocabulario",
    "fr-FR": "Mots stimulants pour améliorer votre vocabulaire",
    "hi-IN": "अपनी शब्दावली को सुधारने के लिए चुनौतीपूर्ण शब्द",
    "ja-JP": "語彙をレベルアップさせるための挑戦的な単語",
    "ko-KR": "어휘를 레벨 업할 수 있는 도전적인 단어",
    "zh-CN": "具有挑战性的单词，可提升您的词汇量",
    "fa-IR": "کلمات چالش برانگیز برای ارتقاء واژگان شما",
    "uk-UA": "Складні слова для підвищення вашого словникового запасу",
    "pt-BR": "Palavras desafiadoras para aprimorar seu vocabulário",
  },
  expert: {
    "en-US": "Expert",
    "es-ES": "Experto",
    "fr-FR": "Expert",
    "hi-IN": "विशेषज्ञ",
    "ja-JP": "エキスパート",
    "ko-KR": "전문가",
    "zh-CN": "专家",
    "fa-IR": "متخصص",
    "uk-UA": "Експерт",
    "pt-BR": "Especialista",
  },
  expert_description: {
    "en-US": "Rare and sophisticated words for vocabulary masters",
    "es-ES": "Palabras raras y sofisticadas para maestros del vocabulario",
    "fr-FR": "Mots rares et sophistiqués pour les maîtres du vocabulaire",
    "hi-IN": "शब्दावली के मास्टर के लिए दुर्लभ और विवेकी शब्द",
    "ja-JP": "語彙マスターのための珍しい洗練された単語",
    "ko-KR": "어휘 마스터를 위한 희귀하고 정교한 단어",
    "zh-CN": "罕见而复杂的词汇，适合词汇大师",
    "fa-IR": "کلمات نادر و پیچیده برای استادان واژگان",
    "uk-UA": "Рідкісні та складні слова для майстрів словникового запасу",
    "pt-BR": "Palavras raras e sofisticadas para mestres do vocabulário",
  },
  start_game: {
    "en-US": "Start game",
    "es-ES": "Comenzar juego",
    "fr-FR": "Démarrer jeu",
    "hi-IN": "खेल शुरू करें",
    "ja-JP": "ゲーム開始",
    "ko-KR": "게임 시작",
    "zh-CN": "开始游戏",
    "fa-IR": "شروع بازی",
    "uk-UA": "Почати гру",
    "pt-BR": "Iniciar jogo",
  },
  start: {
    "en-US": "Start",
    "es-ES": "Comenzar",
    "fr-FR": "Démarrer",
    "hi-IN": "शुरू करें",
    "ja-JP": "開始",
    "ko-KR": "시작",
    "zh-CN": "开始",
    "fa-IR": "شروع",
    "uk-UA": "Почати",
    "pt-BR": "Iniciar",
  },
  skip: {
    "en-US": "Skip",
    "es-ES": "Saltar",
    "fr-FR": "Passer",
    "hi-IN": "छोड़ें",
    "ja-JP": "スキップ",
    "ko-KR": "건너뛰기",
    "zh-CN": "跳过",
    "fa-IR": "رد کردن",
    "uk-UA": "Пропустити",
    "pt-BR": "Pular",
  },
  hint: {
    "en-US": "Hint",
    "es-ES": "Pista",
    "fr-FR": "Indice",
    "hi-IN": "संकेत",
    "ja-JP": "ヒント",
    "ko-KR": "힌트",
    "zh-CN": "提示",
    "fa-IR": "راهنما",
    "uk-UA": "Підказка",
    "pt-BR": "Dica",
  },
  your_clue: {
    "en-US": "Your clue",
    "es-ES": "Tu pista",
    "fr-FR": "Votre indice",
    "hi-IN": "आपका संकेत",
    "ja-JP": "あなたの手がかり",
    "ko-KR": "당신의 단서",
    "zh-CN": "你的线索",
    "fa-IR": "سرنخ شما",
    "uk-UA": "Ваша підказка",
    "pt-BR": "Sua dica",
  },
  time_remaining: {
    "en-US": "Time remaining",
    "es-ES": "Tiempo restante",
    "fr-FR": "Temps restant",
    "hi-IN": "समय शेष",
    "ja-JP": "残り時間",
    "ko-KR": "남은 시간",
    "zh-CN": "剩余时间",
    "fa-IR": "زمان باقی مانده",
    "uk-UA": "Залишився час",
    "pt-BR": "Tempo restante",
  },
  starts_with: {
    "en-US": "Starts with {letter}",
    "es-ES": "Empieza con {letter}",
    "fr-FR": "Commence par {letter}",
    "hi-IN": "{letter} से शुरू होता है",
    "ja-JP": "{letter} で始まる",
    "ko-KR": "{letter} 로 시작",
    "zh-CN": "以 {letter} 开头",
    "fa-IR": "{letter} با شروع می شود",
    "uk-UA": "Починається з {letter}",
    "pt-BR": "Começa com {letter}",
  },
  type_answer: {
    "en-US": "Type your answer",
    "es-ES": "Escribe tu respuesta",
    "fr-FR": "Tapez votre réponse",
    "hi-IN": "अपना उत्तर टाइप करें",
    "ja-JP": "回答を入力してください",
    "ko-KR": "답변을 입력하세요",
    "zh-CN": "输入答案",
    "fa-IR": "پاسخ خود را تایپ کنید",
    "uk-UA": "Введіть свою відповідь",
    "pt-BR": "Digite sua resposta",
  },
  close_menu: {
    "en-US": "Close menu",
    "es-ES": "Cerrar menú",
    "fr-FR": "Fermer le menu",
    "hi-IN": "मेनू बंद करें",
    "ja-JP": "メニューを閉じる",
    "ko-KR": "메뉴 닫기",
    "zh-CN": "关闭菜单",
    "fa-IR": "بستن منو",
    "uk-UA": "Закрити меню",
    "pt-BR": "Fechar menu",
  },
  enable_sounds: {
    "en-US": "Enable sounds",
    "es-ES": "Habilitar sonidos",
    "fr-FR": "Activer les sons",
    "hi-IN": "ध्वनियाँ सक्षम करें",
    "ja-JP": "サウンドを有効にする",
    "ko-KR": "사운드 활성화",
    "zh-CN": "启用声音",
    "fa-IR": "فعال کردن صداها",
    "uk-UA": "Увімкнути звуки",
    "pt-BR": "Ativar sons",
  },
  disable_sounds: {
    "en-US": "Disable sounds",
    "es-ES": "Deshabilitar sonidos",
    "fr-FR": "Désactiver les sons",
    "hi-IN": "ध्वनियाँ बंद करें",
    "ja-JP": "サウンドを無効にする",
    "ko-KR": "사운드 비활성화",
    "zh-CN": "禁用声音",
    "fa-IR": "غیرفعال کردن صداها",
    "uk-UA": "Вимкнути звуки",
    "pt-BR": "Desativar sons",
  },
  restart_game: {
    "en-US": "Restart game",
    "es-ES": "Reiniciar juego",
    "fr-FR": "Redémarrer le jeu",
    "hi-IN": "खेल फिर से शुरू करें",
    "ja-JP": "ゲームを再起動する",
    "ko-KR": "게임 다시 시작",
    "zh-CN": "重新开始游戏",
    "fa-IR": "بازی را دوباره شروع کنید",
    "uk-UA": "Перезапустити гру",
    "pt-BR": "Reiniciar jogo",
  },
  quit_game: {
    "en-US": "Quit game",
    "es-ES": "Salir del juego",
    "fr-FR": "Quitter le jeu",
    "hi-IN": "खेल छोड़ें",
    "ja-JP": "ゲームを終了する",
    "ko-KR": "게임 종료",
    "zh-CN": "退出游戏",
    "fa-IR": "خروج از بازی",
    "uk-UA": "Вийти з гри",
    "pt-BR": "Sair do jogo",
  },

  streak: {
    "en-US": "Streak",
    "es-ES": "Racha",
    "fr-FR": "Série",
    "hi-IN": "लकीर",
    "ja-JP": "ストリーク",
    "ko-KR": "연속",
    "zh-CN": "连胜",
    "fa-IR": "رشته",
    "uk-UA": "Серія",
    "pt-BR": "Sequência",
  },
  points: {
    "en-US": "Points",
    "es-ES": "Puntos",
    "fr-FR": "Points",
    "hi-IN": "अंक",
    "ja-JP": "ポイント",
    "ko-KR": "포인트",
    "zh-CN": "积分",
    "fa-IR": "امتیاز",
    "uk-UA": "Бали",
    "pt-BR": "Pontos",
  },
  percent_complete: {
    "en-US": "Percent complete",
    "es-ES": "Porcentaje completo",
    "fr-FR": "Pourcentage complet",
    "hi-IN": "प्रतिशत पूरा",
    "ja-JP": "完了率",
    "ko-KR": "완료 비율",
    "zh-CN": "完成百分比",
    "fa-IR": "درصد کامل",
    "uk-UA": "Відсоток завершення",
    "pt-BR": "Porcentagem concluída",
  },
  nice_try: {
    "en-US": "Nice try",
    "es-ES": "Buen intento",
    "fr-FR": "Belle tentative",
    "hi-IN": "अच्छा प्रयास",
    "ja-JP": "いい試み",
    "ko-KR": "좋은 시도",
    "zh-CN": "不错的尝试",
    "fa-IR": "تلاش خوب",
    "uk-UA": "Гарна спроба",
    "pt-BR": "Boa tentativa",
  },
  perfect: {
    "en-US": "Perfect",
    "es-ES": "Perfecto",
    "fr-FR": "Parfait",
    "hi-IN": "उत्तम",
    "ja-JP": "完璧",
    "ko-KR": "완벽",
    "zh-CN": "完美",
    "fa-IR": "کامل",
    "uk-UA": "Ідеально",
    "pt-BR": "Perfeito",
  },
  great_job: {
    "en-US": "Great job",
    "es-ES": "Gran trabajo",
    "fr-FR": "Excellent travail",
    "hi-IN": "बहुत बढ़िया",
    "ja-JP": "素晴らしい仕事",
    "ko-KR": "잘 했어요",
    "zh-CN": "干得好",
    "fa-IR": "کار عالی",
    "uk-UA": "Чудова робота",
    "pt-BR": "Ótimo trabalho",
  },
  good_game: {
    "en-US": "Good game",
    "es-ES": "Buen juego",
    "fr-FR": "Bon jeu",
    "hi-IN": "अच्छा खेल",
    "ja-JP": "良いゲーム",
    "ko-KR": "잘 했어요",
    "zh-CN": "好游戏",
    "fa-IR": "بازی خوب",
    "uk-UA": "Гарна гра",
    "pt-BR": "Bom jogo",
  },
  game_summary: {
    "en-US": "Game summary",
    "es-ES": "Resumen del juego",
    "fr-FR": "Résumé du jeu",
    "hi-IN": "खेल का सारांश",
    "ja-JP": "ゲームの概要",
    "ko-KR": "게임 요약",
    "zh-CN": "游戏摘要",
    "fa-IR": "خلاصه بازی",
    "uk-UA": "Підсумок гри",
    "pt-BR": "Resumo do jogo",
  },
  total_time: {
    "en-US": "Total time",
    "es-ES": "Tiempo total",
    "fr-FR": "Temps total",
    "hi-IN": "कुल समय",
    "ja-JP": "合計時間",
    "ko-KR": "총 시간",
    "zh-CN": "总时间",
    "fa-IR": "زمان کل",
    "uk-UA": "Загальний час",
    "pt-BR": "Tempo total",
  },
  words_viewed: {
    "en-US": "Words viewed",
    "es-ES": "Palabras vistas",
    "fr-FR": "Mots vus",
    "hi-IN": "शब्द देखे गए",
    "ja-JP": "表示された単語",
    "ko-KR": "본 단어",
    "zh-CN": "查看的单词",
    "fa-IR": "کلمات مشاهده شده",
    "uk-UA": "Переглянуті слова",
    "pt-BR": "Palavras visualizadas",
  },
  correct_answers: {
    "en-US": "Correct answers",
    "es-ES": "Respuestas correctas",
    "fr-FR": "Réponses correctes",
    "hi-IN": "सही जवाब",
    "ja-JP": "正解",
    "ko-KR": "정답",
    "zh-CN": "正确答案",
    "fa-IR": "پاسخ های صحیح",
    "uk-UA": "Правильні відповіді",
    "pt-BR": "Respostas corretas",
  },
  longest_streak: {
    "en-US": "Longest streak",
    "es-ES": "Racha más larga",
    "fr-FR": "Série la plus longue",
    "hi-IN": "सबसे लंबी चपल",
    "ja-JP": "最長連続",
    "ko-KR": "가장 긴 연속",
    "zh-CN": "最长连胜",
    "fa-IR": "طولانی ترین رشته",
    "uk-UA": "Найдовша серія",
    "pt-BR": "Maior sequência",
  },
  reveal_last_word: {
    "en-US": "Click to reveal final answer",
    "es-ES": "Haga clic para revelar la respuesta final",
    "fr-FR": "Cliquez pour révéler la réponse finale",
    "hi-IN": "अंतिम उत्तर प्रकट करने के लिए क्लिक करें",
    "ja-JP": "最終回答を表示するにはクリックしてください",
    "ko-KR": "마지막 답변을 보려면 클릭하세요",
    "zh-CN": "单击以显示最终答案",
    "fa-IR": "برای نمایش پاسخ نهایی کلیک کنید",
    "uk-UA": "Натисніть, щоб розкрити остаточну відповідь",
    "pt-BR": "Clique para revelar a resposta final",
  },
  cool: {
    "en-US": "Cool",
    "es-ES": "Genial",
    "fr-FR": "Génial",
    "hi-IN": "शानदार",
    "ja-JP": "クール",
    "ko-KR": "멋진",
    "zh-CN": "酷",
    "fa-IR": "خنک",
    "uk-UA": "Круто",
    "pt-BR": "Legal",
  },
  super_cool: {
    "en-US": "Super cool",
    "es-ES": "Súper genial",
    "fr-FR": "Super cool",
    "hi-IN": "सुपर कूल",
    "ja-JP": "スーパークール",
    "ko-KR": "슈퍼 쿨",
    "zh-CN": "超级酷",
    "fa-IR": "خیلی خنک",
    "uk-UA": "Супер круто",
    "pt-BR": "Super legal",
  },
  play_again: {
    "en-US": "Play again",
    "es-ES": "Jugar de nuevo",
    "fr-FR": "Rejouer",
    "hi-IN": "फिर से खेलें",
    "ja-JP": "もう一度プレイ",
    "ko-KR": "다시 플레이",
    "zh-CN": "再玩一次",
    "fa-IR": "دوباره بازی کن",
    "uk-UA": "Грати знову",
    "pt-BR": "Jogar novamente",
  },
  ready_for_more: {
    "en-US": "Ready for another challenge?",
    "es-ES": "¿Listo para otro desafío?",
    "fr-FR": "Prêt pour un autre défi ?",
    "hi-IN": "एक और चुनौती के लिए तैयार?",
    "ja-JP": "別の挑戦の準備はできましたか？",
    "ko-KR": "또 다른 도전 준비 완료?",
    "zh-CN": "准备好迎接另一个挑战了吗？",
    "fa-IR": "آماده یک چالش دیگر هستید؟",
    "uk-UA": "Готові до ще одного виклику?",
    "pt-BR": "Pronto para outro desafio?",
  },
  suggested_packs: {
    "en-US": "Check out these packs",
    "es-ES": "Echa un vistazo a estos paquetes",
    "fr-FR": "Découvrez ces packs",
    "hi-IN": "इन पैक पर एक नज़र डालें",
    "ja-JP": "これらのパックをチェックしてください",
    "ko-KR": "이 팩을 확인하세요",
    "zh-CN": "查看这些包",
    "fa-IR": "این بسته ها را بررسی کنید",
    "uk-UA": "Перегляньте ці пакети",
    "pt-BR": "Confira esses pacotes",
  },
  classic: {
    "en-US": "Classic",
    "es-ES": "Clásico",
    "fr-FR": "Classique",
    "hi-IN": "क्लासिक",
    "ja-JP": "クラシック",
    "ko-KR": "클래식",
    "zh-CN": "经典",
    "fa-IR": "کلاسیک",
    "uk-UA": "Класичний",
    "pt-BR": "Clássico",
  },
  classic_description: {
    "en-US": "Type the correct word based on a clue and first letter.",
    "es-ES": "Escribe la palabra correcta según una pista y la primera letra.",
    "fr-FR":
      "Tapez le mot correct en fonction d'un indice et de la première lettre.",
    "hi-IN": "संकेत और पहले अक्षर के आधार पर सही शब्द टाइप करें।",
    "ja-JP": "手がかりと最初の文字に基づいて正しい単語を入力してください。",
    "ko-KR": "힌트와 첫 글자를 기반으로 올바른 단어를 입력하세요.",
    "zh-CN": "根据提示和首字母输入正确的单词。",
    "fa-IR": "کلمه صحیح را بر اساس سرنخ و حرف اول تایپ کنید",
    "uk-UA": "Введіть правильне слово на основі підказки та першої літери.",
    "pt-BR":
      "Digite a palavra correta com base em uma dica e na primeira letra.",
  },
  mcq: {
    "en-US": "Multiple choice",
    "es-ES": "Opción múltiple",
    "fr-FR": "Choix multiples",
    "hi-IN": "बहुविकल्पी",
    "ja-JP": "マルチプルチョイス",
    "ko-KR": "다중 선택",
    "zh-CN": "多项选择",
    "fa-IR": "چند گزینه ای",
    "uk-UA": "Багаторазовий вибір",
    "pt-BR": "Múltipla escolha",
  },

  mcq_description: {
    "en-US": "Select the correct word based on the given clue.",
    "es-ES": "Selecciona la palabra correcta basándote en la pista dada.",
    "fr-FR": "Sélectionnez le mot correct en fonction de l'indice donné.",
    "hi-IN": "दी गई संकेत के आधार पर सही शब्द का चयन करें।",
    "ja-JP": "与えられた手がかりに基づいて正しい単語を選択してください。",
    "ko-KR": "주어진 단서를 기반으로 올바른 단어를 선택하세요.",
    "zh-CN": "根据给定线索选择正确的单词。",
    "fa-IR": "کلمه صحیح را بر اساس سرنخ داده شده انتخاب کنید",
    "uk-UA": "Виберіть правильне слово на основі даної підказки.",
    "pt-BR": "Selecione a palavra correta com base na dica dada.",
  },
  imcq: {
    "en-US": "Image Match",
    "es-ES": "Combina imagen",
    "fr-FR": "Trouve l'image",
    "hi-IN": "चित्र मिलाओ",
    "ja-JP": "画像探し",
    "ko-KR": "이미지 찾기",
    "zh-CN": "图片配对",
    "fa-IR": "تصویر را مطابقت دهید",
    "uk-UA": "Знайдіть зображення",
    "pt-BR": "Combina imagem",
  },
  imcq_description: {
    "en-US": "Choose the image that matches the given clue.",
    "es-ES": "Elige la imagen que coincide con la pista dada.",
    "fr-FR": "Choisissez l'image qui correspond à l'indice donné.",
    "hi-IN": "दी गई संकेत के साथ मेल खाने वाली छवि का चयन करें।",
    "ja-JP": "与えられた手がかりに一致する画像を選択してください。",
    "ko-KR": "주어진 단서와 일치하는 이미지를 선택하세요.",
    "zh-CN": "选择与给定线索匹配的图像。",
    "fa-IR": "تصویری را که با سرنخ داده شده مطابقت دارد انتخاب کنید",
    "uk-UA": "Виберіть зображення, яке відповідає даній підказці.",
    "pt-BR": "Escolha a imagem que corresponde à dica dada.",
  },
  term_singular: {
    "en-US": "term",
    "es-ES": "palabra",
    "fr-FR": "mot",
    "hi-IN": "शब्द",
    "ja-JP": "単語",
    "ko-KR": "단어",
    "zh-CN": "单词",
    "fa-IR": "کلمه",
    "uk-UA": "слово",
    "pt-BR": "palavra",
  },
  terms_plural: {
    "en-US": "terms",
    "es-ES": "palabras",
    "fr-FR": "mots",
    "hi-IN": "शब्दों",
    "ja-JP": "単語",
    "ko-KR": "단어들",
    "zh-CN": "单词",
    "fa-IR": "کلمات",
    "uk-UA": "слова",
    "pt-BR": "palavras",
  },
  show_first_letter: {
    "en-US": "Show first letter",
    "es-ES": "Mostrar primera letra",
    "fr-FR": "Afficher la première lettre",
    "hi-IN": "पहला अक्षर दिखाएँ",
    "ja-JP": "最初の文字を表示",
    "ko-KR": "첫 글자 표시",
    "zh-CN": "显示首字母",
    "fa-IR": "نمایش حرف اول",
    "uk-UA": "Показати першу літеру",
    "pt-BR": "Mostrar primeira letra",
  },
  show_typing_feedback: {
    "en-US": "Show typing feedback",
    "es-ES": "Mostrar comentarios de escritura",
    "fr-FR": "Afficher les commentaires de dactylographie",
    "hi-IN": "टाइपिंग फीडबैक दिखाएँ",
    "ja-JP": "タイピングフィードバックを表示",
    "ko-KR": "타이핑 피드백 표시",
    "zh-CN": "显示打字反馈",
    "fa-IR": "نمایش بازخورد تایپ",
    "uk-UA": "Показати зворотний зв'язок під час набору тексту",
    "pt-BR": "Mostrar feedback de digitação",
  },
  enable_hint: {
    "en-US": "Enable hint",
    "es-ES": "Habilitar pista",
    "fr-FR": "Activer l'indice",
    "hi-IN": "संकेत सक्षम करें",
    "ja-JP": "ヒントを有効にする",
    "ko-KR": "힌트 사용",
    "zh-CN": "启用提示",
    "fa-IR": "فعال کردن راهنما",
    "uk-UA": "Увімкнути підказку",
    "pt-BR": "Ativar dica",
  },
  enable_time_rewards: {
    "en-US": "Enable time rewards",
    "es-ES": "Habilitar recompensas de tiempo",
    "fr-FR": "Activer les récompenses de temps",
    "hi-IN": "समय पुरस्कार सक्षम करें",
    "ja-JP": "時間報酬を有効にする",
    "ko-KR": "시간 보상 사용",
    "zh-CN": "启用时间奖励",
    "fa-IR": "فعال کردن پاداش زمانی",
    "uk-UA": "Увімкнути винагороди за час",
    "pt-BR": "Ativar recompensas de tempo",
  },
  preview: {
    "en-US": "Preview",
    "es-ES": "Vista previa",
    "fr-FR": "Aperçu",
    "hi-IN": "पूर्वावलोकन",
    "ja-JP": "プレビュー",
    "ko-KR": "미리보기",
    "zh-CN": "预览",
    "fa-IR": "پیش نمایش",
    "uk-UA": "Попередній перегляд",
    "pt-BR": "Pré-visualização",
  },
  copy_link: {
    "en-US": "Copy link",
    "es-ES": "Copiar enlace",
    "fr-FR": "Copier le lien",
    "hi-IN": "लिंक कॉपी करें",
    "ja-JP": "リンクをコピー",
    "ko-KR": "링크 복사",
    "zh-CN": "复制链接",
    "fa-IR": "کپی پیوند",
    "uk-UA": "Скопіювати посилання",
    "pt-BR": "Copiar link",
  },
  copied: {
    "en-US": "Copied!",
    "es-ES": "¡Copiado!",
    "fr-FR": "Copié !",
    "hi-IN": "कॉपी किया गया!",
    "ja-JP": "コピーしました！",
    "ko-KR": "복사됨!",
    "zh-CN": "已复制！",
    "fa-IR": "کپی شد!",
    "uk-UA": "Скопійовано!",
    "pt-BR": "Copiado!",
  },
  show_qr_code: {
    "en-US": "Show QR code",
    "es-ES": "Mostrar código QR",
    "fr-FR": "Afficher le code QR",
    "hi-IN": "क्यूआर कोड दिखाएँ",
    "ja-JP": "QRコードを表示",
    "ko-KR": "QR 코드 표시",
    "zh-CN": "显示二维码",
    "fa-IR": "نمایش کد QR",
    "uk-UA": "Показати QR-код",
    "pt-BR": "Mostrar código QR",
  },
  print: {
    "en-US": "Print",
    "es-ES": "Imprimir",
    "fr-FR": "Imprimer",
    "hi-IN": "प्रिंट करें",
    "ja-JP": "印刷",
    "ko-KR": "인쇄",
    "zh-CN": "打印",
    "fa-IR": "چاپ",
    "uk-UA": "Друк",
    "pt-BR": "Imprimir",
  },
  bookmark: {
    "en-US": "Bookmark",
    "es-ES": "Marcador",
    "fr-FR": "Marque-page",
    "hi-IN": "बुकमार्क करें",
    "ja-JP": "ブックマーク",
    "ko-KR": "북마크",
    "zh-CN": "书签",
    "fa-IR": "نشانه گذاری",
    "uk-UA": "Закладка",
    "pt-BR": "Adicionar aos favoritos",
  },
  unbookmark: {
    "en-US": "Unbookmark",
    "es-ES": "Desmarcar",
    "fr-FR": "Retirer le signet",
    "hi-IN": "अनबुकमार्क करें",
    "ja-JP": "ブックマークを外す",
    "ko-KR": "북마크 해제",
    "zh-CN": "取消书签",
    "fa-IR": "حذف نشانه",
    "uk-UA": "Видалити закладку",
    "pt-BR": "Remover dos favoritos",
  },
  view_collection: {
    "en-US": "View collection",
    "es-ES": "Ver colección",
    "fr-FR": "Voir la collection",
    "hi-IN": "संग्रह देखें",
    "ja-JP": "コレクションを見る",
    "ko-KR": "컬렉션 보기",
    "zh-CN": "查看收藏",
    "fa-IR": "مشاهده مجموعه",
    "uk-UA": "Переглянути колекцію",
    "pt-BR": "Ver coleção",
  },
  duplicate: {
    "en-US": "Duplicate",
    "es-ES": "Duplicar",
    "fr-FR": "Dupliquer",
    "hi-IN": "नकल करें",
    "ja-JP": "複製する",
    "ko-KR": "복제하다",
    "zh-CN": "复制",
    "fa-IR": "تکرار",
    "uk-UA": "Дублювати",
    "pt-BR": "Duplicar",
  },
  assign: {
    "en-US": "Assign",
    "es-ES": "Asignar",
    "fr-FR": "Assigner",
    "hi-IN": "असाइन करें",
    "ja-JP": "割り当てる",
    "ko-KR": "할당하다",
    "zh-CN": "分配",
    "fa-IR": "اختصاص دادن",
    "uk-UA": "Призначити",
    "pt-BR": "Atribuir",
  },
  edit: {
    "en-US": "Edit",
    "es-ES": "Editar",
    "fr-FR": "Éditer",
    "hi-IN": "संपादित करें",
    "ja-JP": "編集する",
    "ko-KR": "편집하다",
    "zh-CN": "编辑",
    "fa-IR": "ویرایش",
    "uk-UA": "Редагувати",
    "pt-BR": "Editar",
  },
  delete: {
    "en-US": "Delete",
    "es-ES": "Eliminar",
    "fr-FR": "Supprimer",
    "hi-IN": "हटाना",
    "ja-JP": "削除する",
    "ko-KR": "삭제하다",
    "zh-CN": "删除",
    "fa-IR": "حذف کردن",
    "uk-UA": "Видалити",
    "pt-BR": "Excluir",
  },
  assignment: {
    "en-US": "Assignment",
    "es-ES": "Asignación",
    "fr-FR": "Affectation",
    "hi-IN": "असाइनमेंट",
    "ja-JP": "割り当て",
    "ko-KR": "과제",
    "zh-CN": "作业",
    "fa-IR": "اختصاص",
    "uk-UA": "Призначення",
    "pt-BR": "Atribuição",
  },
  assignment_results_logged_in: {
    "en-US":
      "The results of this game will be shared with your teacher. Since you're logged in, your name will be submitted as {name}.",
    "es-ES":
      "Los resultados de este juego se compartirán con tu profesor. Dado que has iniciado sesión, tu nombre se enviará como {name}.",
    "fr-FR":
      "Les résultats de ce jeu seront partagés avec votre enseignant. Comme vous êtes connecté, votre nom sera soumis en tant que {name}.",
    "hi-IN":
      "इस खेल के परिणाम आपके शिक्षक के साथ साझा किए जाएंगे। आप लॉग इन हैं, इसलिए आपका नाम {name} के रूप में सबमिट किया जाएगा।",
    "ja-JP":
      "このゲームの結果はあなたの先生と共有されます。ログインしているので、あなたの名前は {name} として提出されます。",
    "ko-KR":
      "이 게임의 결과는 귀하의 선생님과 공유됩니다. 로그인하면 이름이 {name}로 제출됩니다.",
    "zh-CN":
      "此游戏的结果将与您的老师共享。由于您已登录，您的姓名将提交为 {name}。",
    "fa-IR":
      "نتایج این بازی با معلم شما به اشتراک گذاشته می شود. از آنجا که شما وارد شده اید، نام شما به عنوان {name} ارسال می شود.",
    "uk-UA":
      "Результати цієї гри будуть надіслані вашому вчителю. Оскільки ви ввійшли в систему, ваше ім'я буде надіслано як {name}.",
    "pt-BR":
      "Os resultados deste jogo serão compartilhados com seu professor. Como você está conectado, seu nome será enviado como {name}.",
  },
  assignment_results_logged_out: {
    "en-US":
      "The results of this game will be shared with your teacher. Please enter your name below so your teacher can identify your submission.",
    "es-ES":
      "Los resultados de este juego se compartirán con tu profesor. Por favor, introduce tu nombre a continuación para que tu profesor pueda identificar tu envío.",
    "fr-FR":
      "Les résultats de ce jeu seront partagés avec votre enseignant. Veuillez entrer votre nom ci-dessous pour que votre enseignant puisse identifier votre soumission.",
    "hi-IN":
      "इस खेल के परिणाम आपके शिक्षक के साथ साझा किए जाएंगे। कृपया नीचे अपना नाम दर्ज करें ताकि आपके शिक्षक आपकी सबमिशन की पहचान कर सकें।",
    "ja-JP":
      "このゲームの結果はあなたの先生と共有されます。先生があなたの提出物を識別できるように、以下に名前を入力してください。",
    "ko-KR":
      "이 게임의 결과는 귀하의 선생님과 공유됩니다. 선생님이 제출물을 식별할 수 있도록 아래에 이름을 입력하세요.",
    "zh-CN":
      "此游戏的结果将与您的老师共享。请在下面输入您的姓名，以便您的老师识别您的提交。",
    "fa-IR":
      "نتایج این بازی با معلم شما به اشتراک گذاشته می شود. لطفاً نام خود را در زیر وارد کنید تا معلم شما بتواند ارسال شما را شناسایی کند.",
    "uk-UA":
      "Результати цієї гри будуть надіслані вашому вчителю. Будь ласка, введіть своє ім'я нижче, щоб ваш вчитель міг ідентифікувати вашу відправку.",
    "pt-BR":
      "Os resultados deste jogo serão compartilhados com seu professor. Por favor, insira seu nome abaixo para que seu professor possa identificar sua submissão.",
  },
  name_label: {
    "en-US": "Your name",
    "es-ES": "Tu nombre",
    "fr-FR": "Votre nom",
    "hi-IN": "आपका नाम",
    "ja-JP": "あなたの名前",
    "ko-KR": "당신의 이름",
    "zh-CN": "您的名字",
    "fa-IR": "نام شما",
    "uk-UA": "Ваше ім'я",
    "pt-BR": "Seu nome",
  },
  name_placeholder: {
    "en-US": "Use a name that your teacher will recognize.",
    "es-ES": "Usa un nombre que tu profesor reconocerá.",
    "fr-FR": "Utilisez un nom que votre enseignant reconnaîtra.",
    "hi-IN": "एक ऐसा नाम उपयोग करें जिसे आपका शिक्षक पहचानेगा।",
    "ja-JP": "先生が認識できる名前を使用してください。",
    "ko-KR": "선생님이 인식할 수 있는 이름을 사용하세요.",
    "zh-CN": "使用老师能够识别的名字。",
    "fa-IR": "از نامی استفاده کنید که معلم شما آن را بشناسد.",
    "uk-UA": "Використовуйте ім'я, яке ваш вчитель впізнає.",
    "pt-BR": "Use um nome que seu professor reconhecerá.",
  },
  assignment_details: {
    "en-US": "About this assignment",
    "es-ES": "Acerca de esta asignación",
    "fr-FR": "À propos de cette affectation",
    "hi-IN": "इस असाइनमेंट के बारे में",
    "ja-JP": "この課題について",
    "ko-KR": "이 과제에 대하여",
    "zh-CN": "关于此作业",
    "fa-IR": "درباره این اختصاص",
    "uk-UA": "Про це призначення",
    "pt-BR": "Sobre esta atribuição",
  },
  play: {
    "en-US": "Play",
    "es-ES": "Jugar",
    "fr-FR": "Jouer",
    "hi-IN": "खेलें",
    "ja-JP": "プレイ",
    "ko-KR": "재생",
    "zh-CN": "玩",
    "fa-IR": "بازی کردن",
    "uk-UA": "Грати",
    "pt-BR": "Jogar",
  },
  packs: {
    "en-US": "Packs",
    "es-ES": "Paquetes",
    "fr-FR": "Packs",
    "hi-IN": "पैक्स",
    "ja-JP": "パック",
    "ko-KR": "팩",
    "zh-CN": "包",
    "fa-IR": "بسته ها",
    "uk-UA": "Пакети",
    "pt-BR": "Pacotes",
  },
  teachers: {
    "en-US": "Teachers",
    "es-ES": "Profesores",
    "fr-FR": "Professeurs",
    "hi-IN": "शिक्षक",
    "ja-JP": "教師",
    "ko-KR": "교사",
    "zh-CN": "老师",
    "fa-IR": "معلمان",
    "uk-UA": "Вчителі",
    "pt-BR": "Professores",
  },
  pricing: {
    "en-US": "Pricing",
    "es-ES": "Precios",
    "fr-FR": "Tarification",
    "hi-IN": "मूल्य निर्धारण",
    "ja-JP": "価格設定",
    "ko-KR": "가격",
    "zh-CN": "定价",
    "fa-IR": "قیمت گذاری",
    "uk-UA": "Ціни",
    "pt-BR": "Preços",
  },
  read_aloud: {
    "en-US": "Click to read aloud",
    "es-ES": "Haga clic para leer en voz alta",
    "fr-FR": "Cliquez pour lire à voix haute",
    "hi-IN": "जोर से पढ़ने के लिए क्लिक करें",
    "ja-JP": "クリックして音読",
    "ko-KR": "클릭하여 소리내어 읽기",
    "zh-CN": "单击以大声朗读",
    "fa-IR": "برای خواندن با صدای بلند کلیک کنید",
    "uk-UA": "Натисніть, щоб прочитати вголос",
    "pt-BR": "Clique para ler em voz alta",
  },
  unlock_theme: {
    "en-US": "Unlock theme",
    "es-ES": "Desbloquear tema",
    "fr-FR": "Déverrouiller le thème",
    "hi-IN": "थीम अनलॉक करें",
    "ja-JP": "テーマをアンロック",
    "ko-KR": "테마 잠금 해제",
    "zh-CN": "解锁主题",
    "fa-IR": "باز کردن قفل تم",
    "uk-UA": "Розблокувати тему",
    "pt-BR": "Desbloquear tema",
  },
  current_balance: {
    "en-US": "Current balance",
    "es-ES": "Saldo actual",
    "fr-FR": "Solde actuel",
    "hi-IN": "वर्तमान शेष",
    "ja-JP": "現在の残高",
    "ko-KR": "현재 잔액",
    "zh-CN": "当前余额",
    "fa-IR": "موجودی فعلی",
    "uk-UA": "Поточний баланс",
    "pt-BR": "Saldo atual",
  },
  theme: {
    "en-US": "Theme",
    "es-ES": "Tema",
    "fr-FR": "Thème",
    "hi-IN": "थीम",
    "ja-JP": "テーマ",
    "ko-KR": "테마",
    "zh-CN": "主题",
    "fa-IR": "تم",
    "uk-UA": "Тема",
    "pt-BR": "Tema",
  },
  new_balance: {
    "en-US": "New balance",
    "es-ES": "Nuevo saldo",
    "fr-FR": "Nouveau solde",
    "hi-IN": "नया शेष",
    "ja-JP": "新しい残高",
    "ko-KR": "새 잔액",
    "zh-CN": "新余额",
    "fa-IR": "موجودی جدید",
    "uk-UA": "Новий баланс",
    "pt-BR": "Novo saldo",
  },
  go_back: {
    "en-US": "Go back",
    "es-ES": "Volver",
    "fr-FR": "Retour",
    "hi-IN": "वापस जाएँ",
    "ja-JP": "戻る",
    "ko-KR": "뒤로 가기",
    "zh-CN": "返回",
    "fa-IR": "بازگشت",
    "uk-UA": "Повернутися",
    "pt-BR": "Voltar",
  },
  insufficient_balance: {
    "en-US":
      "This theme requires more points. You can earn points by playing games.",
    "es-ES":
      "Este tema requiere más puntos. Puedes ganar puntos jugando juegos.",
    "fr-FR":
      "Ce thème nécessite plus de points. Vous pouvez gagner des points en jouant à des jeux.",
    "hi-IN":
      "इस थीम के लिए अधिक अंक की आवश्यकता है। आप खेल खेलकर अंक कमा सकते हैं।",
    "ja-JP":
      "このテーマにはより多くのポイントが必要です。ゲームをプレイすることでポイントを獲得できます。",
    "ko-KR":
      "이 테마는 더 많은 포인트가 필요합니다. 게임을 플레이하여 포인트를 얻을 수 있습니다.",
    "zh-CN": "此主题需要更多积分。您可以通过玩游戏来赚取积分。",
    "fa-IR":
      "این تم به امتیاز بیشتری نیاز دارد. شما می توانید با بازی کردن امتیاز کسب کنید.",
    "uk-UA":
      "Ця тема потребує більше балів. Ви можете заробити бали, граючи в ігри.",
    "pt-BR":
      "Este tema requer mais pontos. Você pode ganhar pontos jogando jogos.",
  },
  themes_logged_out: {
    "en-US": "Log in to unlock themes",
    "es-ES": "Inicia sesión para desbloquear temas",
    "fr-FR": "Connectez-vous pour déverrouiller les thèmes",
    "hi-IN": "थीम अनलॉक करने के लिए लॉग इन करें",
    "ja-JP": "テーマをアンロックするにはログインしてください",
    "ko-KR": "테마 잠금을 해제하려면 로그인하세요",
    "zh-CN": "登录以解锁主题",
    "fa-IR": "برای باز کردن قفل تم ها وارد شوید",
    "uk-UA": "Увійдіть, щоб розблокувати теми",
    "pt-BR": "Faça login para desbloquear temas",
  },
} as const satisfies Record<string, Record<Locale, string>>;
